import { View } from "react-native";
import ToggleImage from "src/components/ToggleImage";
import useEditCoverGalleryStore from "src/screens/(internal)/EditCoverGalleryModal/hooks/useEditCoverGalleryStore";
import { EditCoverGatheringPhotosTabConfig } from "src/screens/(internal)/EditCoverGalleryModal/types";
import { radiusMedium } from "src/styles/radius";
import { EditCoverGatheringPhotoType } from "../types";

const EditCoverGatheringPhoto = ({
	photo,
	width,
	height,
	marginBottom,
	config,
}: {
	photo: EditCoverGatheringPhotoType;
	width: number;
	height: number;
	marginBottom: number;
	config: EditCoverGatheringPhotosTabConfig;
}) => {
	const selectCover = useEditCoverGalleryStore((state) => state.selectCover);
	const isSelected = useEditCoverGalleryStore((state) =>
		Boolean(
			state.selection &&
				state.selection.variant === "GatheringPhotos" &&
				state.selection.photoId === photo.photoId,
		),
	);

	return (
		<View
			testID="GatheringPhoto"
			style={{
				width,
				height,
				marginBottom,
			}}
		>
			<ToggleImage
				alt="Album photo"
				toggleVariant="SingleSelect"
				containerStyle={{
					borderRadius: radiusMedium,
					overflow: "hidden",
				}}
				src={photo.url}
				dim={{
					width,
					height,
				}}
				isSelected={isSelected}
				onPress={() =>
					selectCover({
						variant: "GatheringPhotos",
						ownerId: photo.ownerId,
						photoId: photo.photoId,
						url: photo.url,
						config,
					})
				}
				recyclingKey={photo.photoId}
			/>
		</View>
	);
};
export default EditCoverGatheringPhoto;
